exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".switch-records-wrapper[data-v-1381d430] {\n  display: flex;\n  justify-content: space-between;\n  width: 10%;\n}\n.switch-records-wrapper.disabled[data-v-1381d430] {\n  pointer-events: none;\n  opacity: 0.5;\n}\n.switch-records-wrapper .prev[data-v-1381d430],\n.switch-records-wrapper .next[data-v-1381d430] {\n  cursor: pointer;\n}\n", ""]);

// exports
